import { useEffect, useRef, useState } from 'react';

export function useOverflowExpand(text: string) {
  const ref = useRef<HTMLElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setIsOverflowing(ref.current.scrollHeight > ref.current.clientHeight);
    }
  }, [text]);

  const toggleExpanded = () => setIsExpanded((prev) => !prev);

  return { ref, isOverflowing, isExpanded, toggleExpanded };
}
